<template>
	<div data-component="icon" :class="`${size} ${isClass ? 'class-icon' : ''} ${classCircle ? 'with-circle' : ''}`">
		<Icon />
	</div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
	slug: { type: String, default: 'burger' },
	isClass: { type: Boolean, default: false },
	classCircle: { type: Boolean, default: false },
	size: {
		type: String,
		default: 'large',
		validator(value) {
			return ['xlarge', 'large', 'medium', 'small'].includes(value)
		},
	},
})

const Icon = defineAsyncComponent(async () => import(`../../../assets/icons/${props.slug}.svg?component`))
</script>

<style lang="scss" scoped>
[data-component='icon'] {
	position: relative;

	display: flex;
	align-items: center;
	justify-content: center;

	&.class-icon {
		:deep(svg) {
			circle {
				fill: none;
				stroke: none;
			}
		}

		&.with-circle {
			:deep(svg) {
				circle {
					fill: var(--icon-color, #000000);
				}
				path {
					fill: var(--icon-secondaryColor, #ffffff);
				}
			}
		}
	}

	&.xlarge {
		height: rs(86, 86);
		width: rs(86, 86);
	}

	&.large {
		height: rs(48, 36);
		width: rs(36, 48);
	}

	&.medium {
		height: rs(24, 24);
		width: rs(24, 24);
	}

	&.small {
		height: rs(16, 16);
		width: rs(16, 16);
	}

	:deep(svg) {
		height: 100%;
		width: 100%;
	}

	:deep(svg) {
		path,
		circle,
		line {
			fill: var(--icon-color, #000000);
			stroke: none;
		}
	}
}
</style>
